<!--
Copyright 2017 ODK Central Developers
See the NOTICE file at the top-level directory of this distribution and at
https://github.com/getodk/central-frontend/blob/master/NOTICE.

This file is part of ODK Central. It is subject to the license terms in
the LICENSE file found in the top-level directory of this distribution and at
https://www.apache.org/licenses/LICENSE-2.0. No part of ODK Central,
including this file, may be copied, modified, propagated, or distributed
except according to the terms contained in the LICENSE file.
-->
<template>
  <modal id="form-delete" :state="state" :hideable="!awaitingResponse" backdrop
    @hide="$emit('hide')">
    <template #title>{{ $t('title') }}</template>
    <template #body>
      <div class="modal-introduction">
        <i18n tag="p" path="introduction[0]">
          <template #name>
            <strong>{{ form.nameOrId() }}</strong>
          </template>
        </i18n>
        <p>{{ $t('introduction[1]') }}</p>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn btn-danger"
          :disabled="awaitingResponse" @click="del">
          {{ $t('action.yesProceed') }} <spinner :state="awaitingResponse"/>
        </button>
        <button type="button" class="btn btn-link" :disabled="awaitingResponse"
          @click="$emit('hide')">
          {{ $t('action.noCancel') }}
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../modal.vue';
import Spinner from '../spinner.vue';
import request from '../../mixins/request';
import { apiPaths } from '../../util/request';
import { noop } from '../../util/util';
import { requestData } from '../../store/modules/request';

export default {
  name: 'FormDelete',
  components: { Modal, Spinner },
  mixins: [request()],
  props: {
    state: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      awaitingResponse: false
    };
  },
  computed: requestData(['form']),
  methods: {
    del() {
      this.delete(apiPaths.form(this.form.projectId, this.form.xmlFormId))
        .then(() => {
          // project.forms and project.lastSubmission may now be out-of-date. If
          // the user navigates to ProjectOverview, project.forms should be
          // updated. project.lastSubmission is not used within ProjectShow.
          this.$emit('success', this.form);
        })
        .catch(noop);
    }
  }
};
</script>

<i18n lang="json5">
{
  "en": {
    // This is the title at the top of a pop-up.
    "title": "Delete Form",
    "introduction": [
      "Are you sure you want to delete the Form {name} and all of its Submissions?",
      "This action cannot be undone."
    ]
  }
}
</i18n>

<!-- Autogenerated by destructure.js -->
<i18n>
{
  "cs": {
    "title": "Odstranit formulář",
    "introduction": [
      "Opravdu chcete odstranit formulář {name} a všechny jeho odeslání?",
      "Tuto akci nelze vrátit zpět."
    ]
  },
  "de": {
    "title": "Formulare löschen",
    "introduction": [
      "Sind Sie sicher, dass Sie das Formular {name} und alle dazugehörigen Übermittlungen löschen wollen?",
      "Diese Aktion kann nicht rückgängig gemacht werden."
    ]
  },
  "es": {
    "title": "Borrar formulario",
    "introduction": [
      "¿Está seguro que desea eliminar el formulario {name} y todos sus envíos?",
      "Esta acción no se puede deshacer."
    ]
  },
  "fr": {
    "title": "Supprimer le formulaire",
    "introduction": [
      "Êtes vous sûr de vouloir supprimer le formulaire {name} et toutes les données soumises ?",
      "Cette action ne peut être annulée."
    ]
  }
}
</i18n>
